import { TabPageDefinition } from '@/components/tab-pages.js';

export const studentTabs = (params: Record<string, string>): TabPageDefinition[] => {
  return [
    {
      label: 'General',
      linkProps: {
        to: '/students/$studentId',
        params: { studentId: params.studentId },
      },
    },
    {
      label: 'Future Sessions',
      linkProps: {
        to: '/students/$studentId/future-sessions',
        params: { studentId: params.studentId },
      },
    },
    {
      label: 'Past Student Feedback',
      linkProps: {
        to: '/students/$studentId/past-student-feedbacks',
        params: { studentId: params.studentId },
      },
      dataTestId: 'students-tab-past-student-feedback',
    },
  ];
};

type AvailableStudentsTabs =
  | 'All students'
  | 'No Future session'
  | 'Multiple schedule'
  | 'Makeup diagnostic'
  | 'Dropped'
  | 'Learning Issue'
  | 'GLA';

export const studentsTabs = (selectedTab?: AvailableStudentsTabs): TabPageDefinition[] => [
  {
    label: 'All students',
    linkProps: {
      to: '/students',
    },
    isSelectedTab: selectedTab === 'All students' || !selectedTab,
  },
  {
    label: 'No Future session',
    linkProps: {
      to: '/students/no-future-sessions',
    },
    isSelectedTab: selectedTab === 'No Future session',
  },
  {
    label: 'Multiple schedule',
    linkProps: {
      to: '/students/multiple-schedule',
    },
    isSelectedTab: selectedTab === 'Multiple schedule',
  },
  {
    label: 'Makeup diagnostic',
    linkProps: {
      to: '/students/makeup-diagnostic',
    },
    isSelectedTab: selectedTab === 'Makeup diagnostic',
  },
  {
    label: 'Dropped',
    linkProps: {
      to: '/students/dropped',
    },
    isSelectedTab: selectedTab === 'Dropped',
  },
  {
    label: 'Learning Issue',
    linkProps: {
      to: '/students/learning-issue',
    },
    isSelectedTab: selectedTab === 'Learning Issue',
  },
  {
    label: 'Missed GLA',
    linkProps: {
      to: '/students/gla',
    },
    isSelectedTab: selectedTab === 'GLA',
  },
];
